import { motion } from "framer-motion";
import {
  ShieldCheck,
  Globe2,
  Gauge,
  Boxes,
  Headphones,
  FileCheck2,
} from "lucide-react";
import MaroonBouncingGraphic from "@/components/site/DecorativeBG";

const ITEMS = [
  {
    icon: Boxes,
    title: "Multiple Manufacturing Capabilities",
    body:
      "From CNC machining and forging to die casting, rubber moulding, fabrication and surface treatment — covered under one partner.",
  },
  {
    icon: Globe2,
    title: "Qualified Supplier Network in India",
    body:
      "Robust ecosystem of audited Indian manufacturing partners enabling reliable supply across commodities and lead times.",
  },
  {
    icon: Gauge,
    title: "Cost Optimisation via Vendor Development",
    body:
      "Continuous vendor development and localisation programmes that drive measurable cost reductions for our customers.",
  },
  {
    icon: ShieldCheck,
    title: "Quality Monitoring & Inspection Support",
    body:
      "In-house quality lab, third-party coordination and full PPAP / FAI documentation across every order.",
  },
  {
    icon: FileCheck2,
    title: "Prototype to Production Supply",
    body:
      "Flexible support across the full product lifecycle — from prototype validation to low and high-volume serial production.",
  },
  {
    icon: Headphones,
    title: "Single Point Communication",
    body:
      "One project owner for sourcing, manufacturing, quality, packaging and export documentation.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 lg:py-32 bg-white overflow-hidden"
    >
      <div className="container-x">
        <div className="relative">
          <MaroonBouncingGraphic />
          <div className="max-w-3xl relative">
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-rule" />
              <span className="eyebrow">Why Tirupati Global Sourcing Company</span>
            </div>
            <h2 className="h-section">
              Six reasons procurement teams
              <br />
              <span className="text-brand-blue">stay with Tirupati Global Sourcing Company.</span>
            </h2>
            <p className="mt-6 text-brand-text/75 text-base lg:text-lg leading-relaxed">
              One Partner, Multiple Manufacturing Capabilities, Global Supply
              Excellence.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
                data-testid={`why-item-${i}`}
                className="group relative bg-white p-8 lg:p-10 transition-all duration-500 hover:bg-brand-navy"
              >
                <div className="flex items-start justify-between">
                  <div className="h-12 w-12 flex items-center justify-center bg-brand-soft text-brand-navy group-hover:bg-brand-orange group-hover:text-white transition-colors duration-500">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="text-[11px] uppercase tracking-[0.22em] text-brand-text/40 group-hover:text-white/50 transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-8 font-heading font-extrabold text-xl text-brand-navy group-hover:text-white transition-colors">
                  {item.title}
                </h3>
                <p className="mt-3 text-brand-text/70 group-hover:text-white/80 leading-relaxed transition-colors">
                  {item.body}
                </p>
                <div className="mt-8 h-px w-10 bg-brand-orange transition-all duration-500 group-hover:w-16" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
